// ----------------------------------------------------------------------
export var Snackbar = function Snackbar() {
  return {
    MuiSnackbarContent: {
      styleOverrides: {
        root: {}
      }
    }
  };
};